import React from 'react';

const TermsAndConditions = () => {
  return (
    <section className="ec-page-content py-5">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center mb-4">
            <div className="section-title">
              <h2 className="fw-bold">Terms &amp; Condition</h2>
            </div>
          </div>
          <div className="col-md-12">
            <div className="ec-common-wrapper">
              <div className="mb-4">
                <h3 className="fw-bold">EESOUQ - TERMS AND CONDITIONS</h3>
                <p>
                  Welcome to Esouq. By accessing or using our website, you agree to the following terms and conditions.
                  Please read them carefully before making a purchase.
                </p>
              </div>

              <div className="mb-4">
                <h4 className="fw-semibold">1. No Return on Open Box:</h4>
                <p>Once the product's box has been opened, it is not eligible for return or exchange under any circumstances.</p>
              </div>

              <div className="mb-4">
                <h4 className="fw-semibold">2. Wrong Product, Model, or Specifications:</h4>
                <p>
                  If you receive a product with the wrong model, color, or storage capacity due to an error on our part,
                  you may request a refund. Please note that this is the only scenario in which a refund will be issued.
                </p>
              </div>

              <div className="mb-4">
                <h4 className="fw-semibold">3. Damage Exchange Policy:</h4>
                <p>
                  In the event that your product arrives damaged, you are eligible for an exchange. However, you must
                  issue a complaint on the same day of delivery to qualify for the exchange.
                </p>
              </div>

              <div className="mb-4">
                <h4 className="fw-semibold">4. Shipping and Delivery:</h4>
                <p>
                  We strive to deliver your products within the estimated delivery time. However, we are not responsible
                  for delays caused by external factors beyond our control.
                </p>
              </div>

              <div className="mb-4">
                <h4 className="fw-semibold">5. Pricing and Payments:</h4>
                <p>
                  All prices are subject to change without prior notice. Payments must be completed through our secure
                  payment options provided on the website.
                </p>
              </div>

              <div className="mb-4">
                <h4 className="fw-semibold">6. Warranty and Liability:</h4>
                <p>
                  Products are covered by the manufacturer's warranty. We are not responsible for any damage resulting
                  from misuse or unauthorized alterations.
                </p>
              </div>

              <div className="mb-4">
                <h4 className="fw-semibold">7. Privacy Policy:</h4>
                <p>
                  Your personal information is protected under our Privacy Policy. Please review this policy to
                  understand how your data is handled.
                </p>
              </div>

              <div className="mb-4">
                <h4 className="fw-semibold">8. Changes to Terms:</h4>
                <p>
                  We reserve the right to update or change these terms at any time. Continued use of our website after
                  changes implies acceptance of the updated terms.
                </p>
              </div>

              <div className="mt-4">
                <p>By purchasing from Esouq, you agree to these terms and conditions.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsAndConditions;
